import React from 'react';
import { useUser } from '@/contexts/UserContext';
import logoRede from '@/images/logo-rede-vistorias.svg';
import classes from '@/leftDrawer/styles.module.scss';

function DrawerTitle() {
  const user = useUser();
  const isClient = user?.authRole === 'ROLE_CLIENT';

  return (
    <div
      className={classes.drawerTitle}
      style={{ backgroundImage: `url(${logoRede})`, backgroundPosition: isClient ? 'left' : 'center' }}
    />
  );
}

export default DrawerTitle;
